import { css } from "@emotion/css";
import { Callout } from "@octopusdeploy/design-system-components";
interface DeleteTemplateCalloutProps {
    templateName: string;
    templateTypeLabel: string;
}
export default ({ templateName, templateTypeLabel }: DeleteTemplateCalloutProps) => (<Callout title="This is a destructive action" type={"danger"}>
        <span className={wordBreak}>
            This action <strong>cannot</strong> be undone. This will permanently delete the {templateTypeLabel} <strong>{templateName}</strong>.
        </span>
    </Callout>);
const wordBreak = css({
    wordBreak: "break-word",
});
